(() => {
  'use strict';

  const NAME_ADDON_ID = 50044354003230;
  const NUMBER_ADDON_ID = 50044354035998;
  const ADDON_PRICE = 2500;
  const CUSTOM_FORM_SELECTOR = 'form[data-q9-custom-form="true"]';

  const money = (cents) => {
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'QAR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency, minimumFractionDigits: 2
      }).format(cents / 100);
    } catch (error) {
      return `QAR ${(cents / 100).toFixed(2)}`;
    }
  };

  const valuesFor = (form) => {
    const name = form.querySelector('[data-q9-player-name]')?.value.trim().toUpperCase() || '';
    const number = form.querySelector('[data-q9-player-number]')?.value.replace(/\D/g, '').slice(0, 3) || '';
    return { name, number };
  };

  const selectedVariantId = (form) => Number(form.querySelector('[name="id"]')?.value || 0);
  const quantityFor = (form) => Math.max(1, Number(form.querySelector('[name="quantity"]')?.value || 1));

  function updateTotal(form, variantPrice) {
    if (Number.isFinite(variantPrice)) form.dataset.q9BasePrice = String(variantPrice);
    const base = Number(form.dataset.q9BasePrice || 0);
    const { name, number } = valuesFor(form);
    const total = base + (name ? ADDON_PRICE : 0) + (number ? ADDON_PRICE : 0);
    const node = form.querySelector('[data-q9-total-price]');
    if (node) node.textContent = money(total);
  }

  function initForm(form) {
    if (form.dataset.q9Ready === 'true') return;
    form.dataset.q9Ready = 'true';

    const nameInput = form.querySelector('[data-q9-player-name]');
    const numberInput = form.querySelector('[data-q9-player-number]');

    nameInput?.addEventListener('input', () => {
      const start = nameInput.selectionStart;
      nameInput.value = nameInput.value.toUpperCase();
      try { nameInput.setSelectionRange(start, start); } catch (_) {}
      updateTotal(form);
    });

    numberInput?.addEventListener('input', () => {
      numberInput.value = numberInput.value.replace(/\D/g, '').slice(0, 3);
      updateTotal(form);
    });

    form.querySelector('[name="id"]')?.addEventListener('change', () => updateTotal(form));
    updateTotal(form);
  }

  function initAllForms(root = document) {
    root.querySelectorAll(CUSTOM_FORM_SELECTOR).forEach(initForm);
  }

  function showStatus(message) {
    let node = document.querySelector('.q9-custom-status');
    if (!node) {
      node = document.createElement('div');
      node.className = 'q9-custom-status';
      node.setAttribute('role', 'status');
      document.body.appendChild(node);
    }
    node.textContent = message;
    node.classList.add('is-visible');
    clearTimeout(showStatus.timer);
    showStatus.timer = setTimeout(() => node.classList.remove('is-visible'), 2400);
  }

  function groupId() {
    return `q9-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
  }

  function buildItems(form) {
    const id = selectedVariantId(form);
    const quantity = quantityFor(form);
    const { name, number } = valuesFor(form);
    const group = groupId();

    const parentProperties = {
      _custom_group_id: group,
      _custom_options: 'true'
    };
    if (name) {
      parentProperties['Player Name'] = name;
      parentProperties._custom_name_addon = 'true';
    }
    if (number) {
      parentProperties['Player Number'] = number;
      parentProperties._custom_number_addon = 'true';
    }

    const items = [{ id, quantity, properties: parentProperties }];
    if (name) items.push({ id: NAME_ADDON_ID, quantity, properties: { _custom_group_id: group, _custom_addon: 'true' } });
    if (number) items.push({ id: NUMBER_ADDON_ID, quantity, properties: { _custom_group_id: group, _custom_addon: 'true' } });
    return { items, id };
  }

  async function addCustomItems(form, event) {
    const productForm = form.closest('product-form');
    const button = form.querySelector('[type="submit"]');
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    const { items, id } = buildItems(form);
    if (!id) return;

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');
    form.querySelector('.loading__spinner')?.classList.remove('hidden');

    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const body = { items };
    if (cart?.getSectionsToRender) {
      body.sections = cart.getSectionsToRender().map((section) => section.id);
      body.sections_url = window.location.pathname;
      cart.setActiveElement?.(document.activeElement);
    }

    try {
      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || 'Could not add item to cart');

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'q9-customization', productVariantId: id, cartData: result });
      }
      if (cart?.renderContents && result.sections) cart.renderContents(result);
      else window.location.href = window.routes?.cart_url || '/cart';

      form.querySelectorAll('[data-q9-player-name],[data-q9-player-number]').forEach((input) => { input.value = ''; });
      updateTotal(form);
      showStatus(document.documentElement.lang.startsWith('ar') ? 'تمت الإضافة إلى السلة' : 'Added to cart');
    } catch (error) {
      productForm?.handleErrorMessage?.(error.message);
      showStatus(error.message || 'Could not add item to cart');
    } finally {
      button.classList.remove('loading');
      button.removeAttribute('aria-disabled');
      form.querySelector('.loading__spinner')?.classList.add('hidden');
      if (typeof CartPerformance !== 'undefined' && event) CartPerformance.measureFromEvent?.('add:user-action', event);
    }
  }

  function q9RowData(row) {
    return {
      group: row?.dataset.q9GroupId || '',
      key: row?.dataset.q9ItemKey || '',
      parent: row?.dataset.q9Parent === 'true',
      addon: row?.dataset.q9Addon === 'true'
    };
  }

  async function updateGroupedLine(row, quantity, sourceElement) {
    const { group, parent } = q9RowData(row);
    if (!group || !parent) return false;

    const cartRoot = row.closest('cart-items, cart-drawer-items');
    if (!cartRoot?.getSectionsToRender) return false;

    const cartState = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());
    const updates = {};
    cartState.items.forEach((item) => {
      if (item.properties?._custom_group_id === group) updates[item.key] = quantity;
    });

    const sections = cartRoot.getSectionsToRender();
    const body = {
      updates,
      sections: sections.map((section) => section.section || section.id),
      sections_url: window.location.pathname
    };

    cartRoot.classList.add('cart__items--disabled');
    try {
      const result = await fetch(window.routes?.cart_update_url || '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then((r) => r.json());

      sections.forEach((section) => {
        const html = result.sections?.[section.section || section.id];
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const target = document.getElementById(section.id);
        if (!target) return;
        const selector = section.selector;
        const source = selector ? doc.querySelector(selector) : doc.querySelector('.shopify-section');
        const destination = selector ? target.querySelector(selector) || target : target;
        if (source && destination) destination.innerHTML = source.innerHTML;
      });

      document.querySelector('cart-drawer')?.classList.toggle('is-empty', result.item_count === 0);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'q9-customization-cart', cartData: result });
      }
      return true;
    } finally {
      cartRoot.classList.remove('cart__items--disabled');
    }
  }

  async function validateCustomCart() {
    const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then((r) => r.json());
    const parents = new Map();
    const addons = new Map();

    cart.items.forEach((item) => {
      const props = item.properties || {};
      const group = props._custom_group_id;
      if (!group) return;
      if (props._custom_addon === 'true' || item.id === NAME_ADDON_ID || item.id === NUMBER_ADDON_ID) {
        if (!addons.has(group)) addons.set(group, []);
        addons.get(group).push(item);
      } else if (props._custom_options === 'true') {
        parents.set(group, item);
      }
    });

    for (const [group, parent] of parents) {
      const lines = addons.get(group) || [];
      const props = parent.properties || {};
      if (props._custom_name_addon === 'true' && !lines.some((x) => x.id === NAME_ADDON_ID && x.quantity === parent.quantity)) return false;
      if (props._custom_number_addon === 'true' && !lines.some((x) => x.id === NUMBER_ADDON_ID && x.quantity === parent.quantity)) return false;
    }
    for (const group of addons.keys()) if (!parents.has(group)) return false;
    return true;
  }

  document.addEventListener('submit', (event) => {
    const form = event.target.closest?.(CUSTOM_FORM_SELECTOR);
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    addCustomItems(form, event);
  }, true);

  document.addEventListener('change', (event) => {
    const input = event.target.closest?.('.cart-item[data-q9-parent="true"] .quantity__input');
    if (!input) return;
    const row = input.closest('.cart-item');
    event.preventDefault();
    event.stopImmediatePropagation();
    updateGroupedLine(row, Math.max(0, Number(input.value || 0)), input).catch(() => location.reload());
  }, true);

  document.addEventListener('click', (event) => {
    const remove = event.target.closest?.('.cart-item[data-q9-parent="true"] cart-remove-button');
    if (remove) {
      const row = remove.closest('.cart-item');
      event.preventDefault();
      event.stopImmediatePropagation();
      updateGroupedLine(row, 0, remove).catch(() => location.reload());
      return;
    }

    const checkout = event.target.closest?.('[name="checkout"], .cart__checkout');
    if (!checkout || checkout.dataset.q9Validated === 'true') return;
    const form = checkout.closest('form');
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    validateCustomCart().then((valid) => {
      if (!valid) throw new Error(document.documentElement.lang.startsWith('ar') ? 'تعذر التحقق من إضافات الطباعة. راجع السلة وحاول مرة أخرى.' : 'Could not validate the printing add-ons. Please review the cart and try again.');
      checkout.dataset.q9Validated = 'true';
      const hidden = document.createElement('input');
      hidden.type = 'hidden'; hidden.name = 'checkout'; hidden.value = 'checkout';
      form.appendChild(hidden);
      form.submit();
    }).catch((error) => showStatus(error.message));
  }, true);

  document.addEventListener('DOMContentLoaded', () => initAllForms());
  document.addEventListener('shopify:section:load', (event) => initAllForms(event.target));

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const sectionId = event?.data?.sectionId;
      const variant = event?.data?.variant;
      document.querySelectorAll(CUSTOM_FORM_SELECTOR).forEach((form) => {
        if (!sectionId || form.closest('product-info')?.dataset.section === sectionId || form.id.includes(sectionId)) {
          updateTotal(form, Number(variant?.price));
        }
      });
    });
  }
})();
